export const itemGap = 12; // gap around each legend item when taking screenshots
const defaultItemSize = 30; // default item size when not taking screenshots

export const getLegendItemSize = (isSizeDynamic: boolean, fontSize: number) =>
  isSizeDynamic ? fontSize + itemGap : defaultItemSize;
